import Panel from '@/components/common/Panel'
import PricingDefaultCard from '@/components/pricing/PricingDefaultCard'
import { pricingData } from '@/data/pricing'

const PricingPanel = () => {
  const pricing = pricingData

  return (
    <div className="p-4">
      <Panel title="Pricing">
        <div className="text-lg">
          <h2>Plans</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-8">
          {pricing.map((pricing) => (
            <PricingDefaultCard key={pricing.id} pricing={pricing} />
          ))}
        </div>
      </Panel>
    </div>
  )
}

export default PricingPanel
